import { Location } from "@angular/common";
import { CanMatchFn, Router } from "@angular/router";
import { SessionNotificationModel } from "../models/sessionNotification.model";
import { inject } from "@angular/core";
import { SessionService } from "../services/session.service";

export const LoginGuard: CanMatchFn = () => {
  const sessionNotification: SessionNotificationModel = inject(SessionService).isTokenExpiredOrNull();
  const router = inject(Router);
  const locationPath = inject(Location).path();

  if(sessionNotification.hasAccess){       
    if(locationPath === '/login')
      router.navigate(['/home']);

    return false;
  }     

  return true;
}